import { WebGLContext } from 'features/assetDatabase/contexts/WebGLLayer'
import { ForecastAssetViz } from 'features/assetVizAdapter'
import React, { useContext, useEffect } from 'react'
import {
  GeckoAssetModel,
  GeckoColorScaleThreshold,
  GeckoComponent,
  GeckoComponentDataFrame,
} from 'types'

export interface ManagedAssetVizProps {
  id: string
  assetModel: GeckoAssetModel | undefined
  components: readonly GeckoComponent[] | undefined
  getColorThresholdForComponent?: (
    cdf: GeckoComponentDataFrame
  ) => GeckoColorScaleThreshold | undefined
  componentDataFrame: GeckoComponentDataFrame | undefined
  assetColor: string
  setAssetImage?: React.Dispatch<React.SetStateAction<string | null>>
}

const NUMBER_OF_ASSET_VIZ = 8

export const ManagedAssetViz: React.FC<ManagedAssetVizProps> = ({
  id,
  assetModel,
  components,
  getColorThresholdForComponent,
  componentDataFrame,
  assetColor,
  setAssetImage,
}) => {
  const { setAssetVizRenderingMap, assetVizRenderingMap } =
    useContext(WebGLContext)

  useEffect(() => {
    if (
      assetVizRenderingMap.size <= NUMBER_OF_ASSET_VIZ &&
      !assetVizRenderingMap.has(id)
    ) {
      const updatedMap = new Map(assetVizRenderingMap)
      updatedMap.set(
        id,
        <ForecastAssetViz
          id={id}
          assetColor={assetColor}
          assetModel={assetModel}
          getColorThresholdForComponent={getColorThresholdForComponent}
          components={components}
          componentDataFrames={componentDataFrame ? [componentDataFrame] : []}
          setAssetImage={setAssetImage}
          offscreenRender={true}
        />
      )

      setAssetVizRenderingMap(updatedMap)
    }
  }, [
    assetColor,
    assetModel,
    assetVizRenderingMap,
    getColorThresholdForComponent,
    componentDataFrame,
    components,
    id,
    setAssetImage,
    setAssetVizRenderingMap,
  ])

  return <>{assetVizRenderingMap.get(id)}</>
}
